import { useRef } from "react";
import { observer } from "mobx-react-lite";
import { useReactToPrint } from "react-to-print";
import { Button } from "@/components/ui/button";
import AppDialog from "@/components/common/AppDialog";
import { useTran } from "@/hooks";
import {
  useESGReportBuilderStore,
  useESGDisclosureSelectionStore,
  useESGReportWorkflowStore,
} from "@/features/esg/hooks/useESGReportStore";
import ESGPrintableReport from "./ESGPrintableReport";

const ESGReportPreviewModal = observer(({ open, onOpenChange }) => {
  const { t } = useTran();
  const { reportName, framework, orgName } = useESGReportBuilderStore();
  const { metricMappings } = useESGDisclosureSelectionStore();
  const { reviewExportFramework } = useESGReportWorkflowStore();
  const contentRef = useRef(null);

  const orgPart = orgName ? `_${orgName.replace(/\s+/g, "_")}` : "";
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `${reportName || "ESG_Report"}_${framework}${orgPart}`,
  });

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      size="2xl"
      header={
        <div className="flex w-full items-center justify-between">
          <p className="text-xl font-semibold text-foreground">
            {t("ESG Report Preview")}
          </p>
          <Button onClick={handlePrint} className="gap-2">
            {t("Print / Save as PDF")}
          </Button>
        </div>
      }
      bodyClassName="!p-0"
      contentClassName="max-h-[90vh]"
    >
      <div className="nx-scroll max-h-[75vh] overflow-y-auto px-6 py-4">
        <div
          ref={contentRef}
          id="esg-print-area"
          className="mx-auto bg-white"
          style={{ maxWidth: "210mm" }}
        >
          <ESGPrintableReport
            exportFramework={reviewExportFramework}
            metricMappings={metricMappings}
          />
        </div>
      </div>
    </AppDialog>
  );
});

export default ESGReportPreviewModal;
